import AvatarUpload from 'components/common/AvatarUpload';
import { Card, Col, Row, Form, Modal, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import {
    faPencil,
    faUserGroup
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { ProfileData } from './DataDefinitions';
import Button from 'components/base/Button';
import { useState } from 'react';
interface ProfileCardProps {
    showAbout?: boolean;
    avatar: string;
    className?: string;
    profile?: ProfileData;
    onProfileChange: (name: string, value: any) => void;
    onChangeProfileImage: (image: File | null) => void;
    onChangeAboutMe: (aboutMe: string) => void;
}


const ProfileCard = ({
    showAbout,
    avatar,
    className,
    profile,
    onChangeProfileImage,
    onChangeAboutMe
}: ProfileCardProps) => {

    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false);
    const [currentAboutMe, setCurrentAboutMe] = useState('');

    // Function to handle input changes
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setCurrentAboutMe(value);
    };

    // Function to handle input changes
    const handleSaveAndCloseModal = () => {
        setShowModal(false);
        onChangeAboutMe(currentAboutMe);
    };

    let coach_mentor = ''

    if (profile?.is_coach === 'on' && profile.is_mentor === 'off') coach_mentor = 'Coach'
    if (profile?.is_coach === 'off' && profile.is_mentor === 'on') coach_mentor = 'Mentor'
    if (profile?.is_coach === 'on' && profile.is_mentor === 'on') coach_mentor = 'Coach/Mentor'

    return (
        <>
            <Card className={className}>
                <Card.Header
                    className="position-relative mb-6 mt-2"
                    style={{ minHeight: '50px' }}
                >

                    <AvatarUpload
                        size="4xl"
                        src={profile?.picture ?? avatar}
                        thumbnail
                        className="feed-avatar-profile"
                        onChange={onChangeProfileImage}
                    />
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col xs={12}>
                            <div className="d-flex flex-wrap mb-2 align-items-center">
                                <h3 className="me-2">{profile?.first_name + " " + profile?.last_name}</h3>
                                <span className="fw-normal fs-8">{coach_mentor}</span>
                            </div>
                            <div className="d-flex flex-wrap gap-y-2 gap-x-4 d-xl-block d-xxl-flex align-items-center">
                                <div className="d-flex mb-xl-2 mb-xxl-0">
                                    <FontAwesomeIcon
                                        icon={faUserGroup}
                                        className="fs-10 me-2 me-lg-1 me-xl-2"
                                    />
                                    <h6 className="mb-0">
                                        {profile?.contacts_count}
                                        <span className="fw-semi-bold ms-1">{t("ProfileCard.contacts")}</span>
                                    </h6>
                                </div>

                            </div>
                            {showAbout && (
                                <div className="mt-4">
                                    <p className="fw-semi-bold mb-0">
                                        {t("ProfileCard.about_me")}
                                        <Link to="#!">
                                            <FontAwesomeIcon onClick={() => { setCurrentAboutMe(profile?.about_me ?? ''); setShowModal(true); }}
                                                icon={faPencil}
                                                className="fs-10 text-500 ms-3"
                                            />
                                        </Link>
                                    </p>
                                    <p className="text-700 mb-0">
                                        {profile?.about_me !== null ? ('“' + profile?.about_me + '”') : (t("ProfileCard.empty_about_me"))}
                                    </p>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Modal
                show={showModal}
                size="xl"
                contentClassName="overflow-hidden"
            >
                <Modal.Header className="position-relative p-0">
                </Modal.Header>
                <Modal.Body className="p-0">
                    <Row className="g-0">
                        <Col xs={10} xl={10} className="border-300 bg-100">
                            <div className="px-5 px-lg-6 py-4 bg-white">
                                <h3 className="fw-bolder lh-sm mb-5">{t("ProfileCard.about_me")}</h3>
                            </div>
                        </Col>
                    </Row>

                    <Row className="m-4 g-0">
                        <Col xs={12} xl={12} className="border-300 bg-100">
                            <Form.Floating>
                                <Form.Control size="lg" as="textarea" rows={3} style={{ height: '100%' }}
                                    id="about_me"
                                    type="text"
                                    placeholder={t("ProfileCard.about_me")}
                                    className="form-icon-input"
                                    value={currentAboutMe}
                                    name="about_me"
                                    onChange={handleInputChange}
                                />
                            </Form.Floating>
                        </Col>
                    </Row>

                    <Row className="m-4 g-0">
                        <div className='d-flex gap-4'>
                            <div>
                                <Button variant="primary" className=" ms-auto" onClick={() => handleSaveAndCloseModal()}>
                                    {t("ProfileCard.save")}
                                </Button>
                            </div>
                            <div style={{ textAlign: 'end' }}>
                                <Button variant="warning" className=" ms-auto" onClick={() => { setCurrentAboutMe(profile?.about_me ?? ''); setShowModal(false); }}>
                                    {t("ProfileCard.discard_changes")}
                                </Button>
                            </div>
                        </div>

                    </Row>


                </Modal.Body>
            </Modal>
        </>
    );
};

export default ProfileCard;
